import React, { Component } from 'react'
import './GeomConvert.scss';
import { Input, Button,Checkbox, message } from 'antd';
import { ArrowRightOutlined, ArrowLeftOutlined,CopyOutlined,DownloadOutlined,SendOutlined } from '@ant-design/icons';
import { geometryUtil } from './../../util/geometryUtil'
import context from '../../context';
import MapWidgetUI from '../../components/MapWidgetUI';
const { TextArea } = Input;
const { Search } = Input;

const demoData = {
    "polygon": {
      "type": "Polygon",
      "coordinates": [
        [
          [
            120.01585,
            36.21879
          ],
          [
            120.001431,
            36.220594
          ],
          [
            119.994564,
            36.228764
          ],
          [
            119.995766,
            36.23915
          ],
          [
            119.994907,
            36.248599
          ],
          [
            119.994049,
            36.255625
          ],
          [
            119.993877,
            36.266525
          ],
          [
            119.992676,
            36.281853
          ],
          [
            120.003233,
            36.291403
          ],
          [
            120.053358,
            36.296734
          ],
          [
            120.05971,
            36.294101
          ],
          [
            120.075417,
            36.284412
          ],
          [
            120.077648,
            36.277218
          ],
          [
            120.079107,
            36.270781
          ],
          [
            120.081682,
            36.261372
          ],
          [
            120.082712,
            36.249947
          ],
          [
            120.081253,
            36.232227
          ],
          [
            120.068893,
            36.228488
          ],
          [
            120.057907,
            36.222255
          ],
          [
            120.043831,
            36.22087
          ],
          [
            120.01585,
            36.21879
          ]
        ]
      ]
    },
    "point": {
      "type": "Point",
      "coordinates": [120.035344362259,36.2550971456653]
    }
}
export default class GeomConvert extends Component {
  constructor(props) {
    super(props)
    this.state = {
      wkt: "",
      geom: "",
      geofence: "",
      latLng:null,
      pegging:false,
    }
  }
  locate = (value, event) => {
    // console.log(value,event);
    const { pegging } = this.state;
    if(!value) return;
    let separator = ",";
    const separatorarr = [",","，"," "];
    separatorarr.forEach(item=>{
      if(value.trim().search(item)>-1){
        separator = item;
      }
    })
    const coordinates = value.trim().split(separator)?.map(item=>Number(item)).reverse();
    this.props.onAddPoint(coordinates);
  }
  addToMap = () => {
    const { wkt,geom } = this.state;
    if(!wkt&&!geom){
      return;
    }
    let value = geom?geom:geometryUtil.wktToGeoJSON(wkt);
    let geometry = ((typeof value) === "object")?value:JSON.parse(value);
    this.props.onAddLayer(geometry.coordinates);
  }
  wKTtoGeoJson = () => {
    const { wkt } = this.state;
     if (!wkt) return;
    let value = geometryUtil.wktToGeoJSON(wkt);
    this.setState({
      geom: (JSON.stringify(value, null, 10))
    });
  }
  geoJsontoWKT = () => {
    const { geom } = this.state;
    if (!geom) return;
    let value = geometryUtil.geoJSONToWkt(JSON.parse(geom));
    this.setState({
      wkt: value
    });
  }

  wKTGeofence = () => {
    const { wkt } = this.state;
    if (!wkt) return;
    let value = geometryUtil.parsePolygonToCoords(wkt);
    console.log(value);
    // this.setState({
    //   geofence: value
    // });
  }
  geofencetoWKT = () => {
    const { geofence } = this.state;
    if (!geofence) return;
    let value = `POLYGON((${JSON.parse(geofence).map(m=>`${m.y} ${m.x}`).join(",")}))`;
    this.setState({
      wkt: value
    });
  }
  _onChange = (e, type) => {
    if (type === "wkt") {
      this.setState({
        wkt: e.target.value
      })
    } else {
      this.setState({
        geom: e.target.value
        // geom:(JSON.stringify(e.target.value,null,10))
      })
    }
  }
  onPeggingChange = (event) => {
    this.setState({pegging: event.target.checked});
  }
  loadExample = (type) => {
    console.log(type);
    if(type==="wkt"){
      this.setState({wkt: geometryUtil.geoJSONToWkt(demoData.polygon)});
    }if(type==="json"){
      this.setState({geom: JSON.stringify(demoData.polygon)});
    }else{
      this.setState({geofence: JSON.stringify(demoData.polygon.coordinates[0].map(m=>({y:m[0],x:m[1]})))});
    }
  }
  copyContent = ()=>{
    const { wkt,geom,geofence } = this.state;
    navigator.clipboard.writeText(geom||wkt||geofence);
  }
  copyCoord = ()=>{
    const { latLng } = this.props;
    navigator.clipboard.writeText(`${latLng.lng},${latLng.lat}`);
    message.info("复制成功！");
  }
  download = ()=>{
    const { wkt,geom,geofence } = this.state;
    var eleLink = document.createElement('a');
    eleLink.download = "example.txt";
    eleLink.style.display = 'none';
    // 字符内容转变成blob地址
    var blob = new Blob([geom||wkt||geofence]);
    eleLink.href = URL.createObjectURL(blob);
    // 触发点击
    document.body.appendChild(eleLink);
    eleLink.click();
    // 然后移除
    document.body.removeChild(eleLink);
  }
  render() {
    const { wkt,geom,geofence,pegging } = this.state;
    const { latLng } = this.props;

    // const maps = [
    //   {label:"Geofence Coordinates",btnName:"加载示例",onBtnName:"loadExample",onClickName="_onChange"},
    //   {onRightName:"geofencetoWKT",onLeftName="wKTGeofence"},
    //   {label:"Well-Known-Text",btnName:"加载示例",onBtnName:"loadExample",onClickName="_onChange"},
    //   {label:"GeoJSON",btnName:"加载示例",onBtnName:"loadExample",onClickName="_onChange"},
    //   {onRightName:"wKTtoGeoJson",onLeftName="geoJsontoWKT"},
    // ];
    return <div className="geom-convert">
      <div className="geom-text">

        <div className="content">
          <div className="head">
            <div className="sub-title">Geofence Coordinates</div>
            <Button className="example-laod" onClick={()=>this.loadExample("geofence")}>加载示例</Button>
          </div>
          <TextArea value={geofence} rows={15} onChange={(e) => this._onChange(e, "geofence")} />
        </div>

        <div className="convert_btn">
          <Button onClick={this.geofencetoWKT}><ArrowRightOutlined /></Button>
          <Button onClick={this.wKTGeofence}><ArrowLeftOutlined /></Button>
        </div>

        <div className="content">
          <div className="head">
            <div className="sub-title">Well-Known-Text</div>
            <Button className="example-laod" onClick={()=>this.loadExample("wkt")}>加载示例</Button>
          </div>
          <TextArea value={wkt} rows={15} onChange={(e) => this._onChange(e, "wkt")} />
        </div>
        
        <div className="convert_btn">
          <Button onClick={this.wKTtoGeoJson}><ArrowRightOutlined /></Button>
          <Button onClick={this.geoJsontoWKT}><ArrowLeftOutlined /></Button>
        </div>

        <div className="content">
          <div className="head">
            <div className="sub-title">GeoJSON</div>
            <Button className="example-laod" onClick={()=>this.loadExample("json")}>加载示例</Button>
          </div>
          <TextArea value={geom} rows={15} onChange={(e) => this._onChange(e, "json")} />
        </div>

      </div>

      <div className="tool-btn">
        <div className="btn-group">
          <Button variant="dashed" type="primary" ghost onClick={this.copyContent}><CopyOutlined />复制</Button>
          <Button variant="dashed" style={{background:"#9cd9d9"}} onClick={this.download}><DownloadOutlined />下载</Button>
          <Button variant="dashed" type="primary" danger ghost onClick={this.addToMap}><SendOutlined />添加到地图</Button>
        </div>

        <div className="coordinate-display">
          <Search allowClear placeholder="请输入坐标如:113.99414,37.43997" style={{width:"360px"}} onSearch={this.locate}/>
          {/* <Checkbox checked={pegging} onChange={this.onPeggingChange}>坐标反查</Checkbox> */}
          <div className="coordinate-text">当前坐标：<span style={{cursor:"pointer"}} title='点击复制' onClick={this.copyCoord}>{latLng&&`${latLng.lng},${latLng?.lat}`}</span></div>
        </div>
      </div>
    </div>
  }
}